import { render } from "./ParticleFlowBackground.vue?vue&type=template&id=38ea1ede&scoped=true"
import script from "./ParticleFlowBackground.vue?vue&type=script&lang=js"
export * from "./ParticleFlowBackground.vue?vue&type=script&lang=js"

import "./ParticleFlowBackground.vue?vue&type=style&index=0&id=38ea1ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ea1ede"]])

export default __exports__